import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=3a345f24&scoped=true&"
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"
import style0 from "./carousel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./carousel.vue?vue&type=style&index=1&id=3a345f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a345f24",
  null
  
)

export default component.exports